import { cn } from "@/lib/utils";

type PictureProps = {
  avifSrcSet: string;
  webpSrcSet: string;
  src: string;
  sizes: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  decoding?: "async" | "sync" | "auto";
  ariaHidden?: boolean;
  /** Fill a positioned parent. Avoids `display: contents`, which can hide the LCP `<img>` from the preload scanner. */
  fill?: boolean;
};

export function Picture({
  avifSrcSet,
  webpSrcSet,
  src,
  sizes,
  alt,
  width,
  height,
  className,
  loading = "lazy",
  fetchPriority,
  decoding = "async",
  ariaHidden,
  fill = false,
}: PictureProps) {
  return (
    <picture className={fill ? cn("absolute inset-0 block h-full w-full", className) : "contents"}>
      <source type="image/avif" srcSet={avifSrcSet} sizes={sizes} />
      <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} />
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        sizes={sizes}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding={decoding}
        aria-hidden={ariaHidden}
        className={cn("h-full w-full object-cover", !fill && className)}
      />
    </picture>
  );
}
